import { render, staticRenderFns } from "./MarketingSiteEditor.vue?vue&type=template&id=00d126da&scoped=true"
import script from "./MarketingSiteEditor.vue?vue&type=script&lang=js"
export * from "./MarketingSiteEditor.vue?vue&type=script&lang=js"
import style0 from "./MarketingSiteEditor.vue?vue&type=style&index=0&id=00d126da&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d126da",
  null
  
)

export default component.exports